import {
  Center,
  Divider,
  Group,
  HoverCard,
  Stack,
  Switch,
  Text,
  Tooltip,
  UnstyledButton,
} from '@mantine/core';
import { IconSun } from '@tabler/icons-react';
import { useNavigate } from 'react-router';
import Config from 'src/common/Config';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { useFlags } from './FlagsHook';
import useFlagOverrides from './useFlagOverrides';
import usePinnedFlags from './usePinnedFlags';

export default function PinnedFlagsPopover({ onClick }: { onClick: () => void }) {
  const { pinned, hasPinned } = usePinnedFlags();
  const flags = useFlags();
  const { overrides, setOverride } = useFlagOverrides();
  const navigate = useNavigate();
  const isDev = Config.isDev();

  const icon = (
    <Center onClick={onClick} w={40} h={40} style={{ cursor: 'pointer' }}>
      <IconSun stroke={1} color="white" />
    </Center>
  );

  if (!isDev || !hasPinned) {
    return (
      <Tooltip label="Secret menu" withArrow position="right" color="white" c="black">
        {icon}
      </Tooltip>
    );
  }

  return (
    <HoverCard
      width={280}
      position="bottom-end"
      shadow="lg"
      withinPortal
      openDelay={200}
      radius="md"
    >
      <HoverCard.Target>{icon}</HoverCard.Target>
      <HoverCard.Dropdown p={0}>
        <Stack gap={0}>
          <Group justify="space-between" px="md" pt="sm" pb="xs">
            <Text size="xs" fw={FONT_WEIGHTS.semibold} c="gray.6" tt="uppercase">
              Pinned flags
            </Text>
            <UnstyledButton onClick={() => navigate('/secret-menu/feature-flags')}>
              <Text size="xs" fw={FONT_WEIGHTS.medium} c="brand.6">
                View all
              </Text>
            </UnstyledButton>
          </Group>
          <Divider color="gray.2" />
          {pinned.map(key => (
            <Group key={key} justify="space-between" wrap="nowrap" px="md" py="xs">
              <Text
                size="textSm"
                fw={key in overrides ? FONT_WEIGHTS.semibold : FONT_WEIGHTS.medium}
                c={key in overrides ? 'brand.6' : 'gray.8'}
                style={{ fontFamily: 'var(--mantine-font-family-monospace)' }}
              >
                {key}
              </Text>
              <Switch
                checked={flags[key]}
                onChange={() => setOverride(key, !flags[key])}
                size="xs"
              />
            </Group>
          ))}
        </Stack>
      </HoverCard.Dropdown>
    </HoverCard>
  );
}
